import { getTimestamp, now } from 'owa-datetime';
import { lazyHandleLoadItemResponse } from 'mini-mail-list-store';
import { loadItemWithErrorHandling } from './loadItemWithErrorHandling';
import { RowInfoToGetRSVP } from 'mini-common-schema/lib/schema/RowInfoToGetRSVP';
import {
    setTimeToFetchConflictingMeetings,
    setTimeToFetchMeetingMessage,
} from 'mini-meeting-invite/lib/store/Store';
import {
    getBasicMeetingAdditionalProperties,
    getCalendarEventSpecialProperties,
    getConflictingMeetingsInfoAdditionalProperties,
    getMeetingMailAdditionalProperties,
} from 'mini-meeting-invite/lib/utils/additionalPropertiesGetters';

export const fetchMeetingMessageItems = (infoForRsvpCandidateRows: RowInfoToGetRSVP[]) => {
    lazyHandleLoadItemResponse.import();

    fetchBasicInfo(infoForRsvpCandidateRows);

    fetchConflictingMeetingsInfo(infoForRsvpCandidateRows);
};

const fetchBasicInfo = (infoForRsvpCandidateRows: RowInfoToGetRSVP[]) => {
    const timestampBeforeServiceCall = getTimestamp(now());

    const fetchedMeetingMessageSuccessfully = async (timestampOfCompletion?: number) => {
        const timestampAfterServiceCallEnds = timestampOfCompletion || getTimestamp(now());
        await lazyHandleLoadItemResponse.importAndExecute(infoForRsvpCandidateRows);
        const timestampPostRsvpProcessing = getTimestamp(now());
        infoForRsvpCandidateRows.map(rowInfo => {
            setTimeToFetchMeetingMessage(
                rowInfo?.itemId,
                timestampBeforeServiceCall,
                timestampAfterServiceCallEnds,
                timestampPostRsvpProcessing
            );
        });
    };

    loadItemWithErrorHandling(
        infoForRsvpCandidateRows,
        [
            ...getBasicMeetingAdditionalProperties(),
            ...getMeetingMailAdditionalProperties(),
            ...getCalendarEventSpecialProperties(),
        ],
        0 /** retryCount */,
        fetchedMeetingMessageSuccessfully
    );
};

export const fetchConflictingMeetingsInfo = (
    infoForRsvpCandidateRows: RowInfoToGetRSVP[]
): void => {
    const timestampBeforeServiceCall = getTimestamp(now());

    const fetchedConflictingMeetingsSuccessfully = (
        itemId: string,
        timestampOfCompletion?: number
    ) => {
        const timestampAfterServiceCallEnds = timestampOfCompletion || getTimestamp(now());
        setTimeToFetchConflictingMeetings(
            itemId,
            timestampBeforeServiceCall,
            timestampAfterServiceCallEnds
        );
    };
    const conflictingMeetingsInfoAdditionalProperties = getConflictingMeetingsInfoAdditionalProperties();

    infoForRsvpCandidateRows.map(rowInfo => {
        loadItemWithErrorHandling(
            [rowInfo],
            conflictingMeetingsInfoAdditionalProperties,
            0 /** retryCount */,
            (timestampOfCompletion: number) =>
                fetchedConflictingMeetingsSuccessfully(rowInfo?.itemId, timestampOfCompletion)
        );
    });
};
